import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/title.png';
import _imports_1 from '@/assets/tip.png';
import _imports_2 from '@/assets/chrome.png';
const _withScopeId = n => (_pushScopeId("data-v-5857e357"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "welcome flex flex-col h-full justify-start mx-auto"
};
const _hoisted_2 = {
  class: "gpt-model bg-white rounded"
};
const _hoisted_3 = {
  class: "left"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "prefix"
}, "模型切换", -1));
const _hoisted_5 = {
  class: "selected"
};
const _hoisted_6 = {
  class: "right"
};
const _hoisted_7 = {
  class: "list w-full"
};
const _hoisted_8 = ["onClick", "onMouseover"];
const _hoisted_9 = {
  class: "name select-none"
};
const _hoisted_10 = {
  key: 0,
  class: "desc-card"
};
const _hoisted_11 = {
  class: "title"
};
const _hoisted_12 = {
  class: "desc"
};
const _hoisted_13 = {
  class: "status"
};
const _hoisted_14 = {
  class: "item"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "推理能力", -1));
const _hoisted_16 = {
  class: "status-bar"
};
const _hoisted_17 = {
  class: "item"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "推理速度", -1));
const _hoisted_19 = {
  class: "status-bar"
};
const _hoisted_20 = {
  class: "item"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "表达能力", -1));
const _hoisted_22 = {
  class: "status-bar"
};
const _hoisted_23 = {
  class: "md:mt-5 lg:max-w-screen-lg"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "w-32 mx-auto my-5 md:my-7"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
})], -1));
const _hoisted_25 = {
  class: "grid justify-items-center grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 mx-auto text-sm"
};
const _hoisted_26 = {
  class: "h-item flex flex-col items-center"
};
const _hoisted_27 = ["src"];
const _hoisted_28 = {
  class: "text-base mt-2"
};
const _hoisted_29 = {
  class: "text-center text-xs text-gray-400"
};
const _hoisted_30 = {
  class: "mt-5"
};
const _hoisted_31 = {
  class: "hidden sm:flex my-5 text-xs text-center justify-center items-center flex-wrap"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-4 mr-1",
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text-indigo-700"
}, "Ctrl+D ", -1));
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-4 ml-1 cursor-pointer",
  src: _imports_2,
  alt: ""
}, null, -1));
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text-indigo-700 cursor-pointer underline mx-1"
}, "快捷方式文件", -1));
const _hoisted_36 = [_hoisted_34, _hoisted_35];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ai_dot = _resolveComponent("ai-dot");
  const _component_ArrowDownBold = _resolveComponent("ArrowDownBold");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_ArrowUpBold = _resolveComponent("ArrowUpBold");
  const _component_Select = _resolveComponent("Select");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    ref: "target",
    class: "model-selector rounded",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.showModelList = !_ctx.showModelList)
  }, [_createVNode(_component_ai_dot, {
    target: "changeMode"
  }), _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.model), 1)]), _createElementVNode("div", _hoisted_6, [_withDirectives(_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_ArrowDownBold)]),
    _: 1
  }, 512), [[_vShow, !_ctx.showModelList]]), _withDirectives(_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_ArrowUpBold)]),
    _: 1
  }, 512), [[_vShow, _ctx.showModelList]])])], 512), _withDirectives(_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, item => {
    return _openBlock(), _createElementBlock("div", {
      key: item.value,
      class: _normalizeClass(["list-item", {
        selected: _ctx.model === item.value
      }]),
      onClick: $event => _ctx.selectedModel(item.name),
      onMouseover: $event => _ctx.hover(item),
      onMouseleave: _cache[1] || (_cache[1] = $event => _ctx.hoverItem = null)
    }, [_createElementVNode("div", _hoisted_9, _toDisplayString(item.name), 1), _ctx.model === item.value ? (_openBlock(), _createBlock(_component_el_icon, {
      key: 0
    }, {
      default: _withCtx(() => [_createVNode(_component_Select)]),
      _: 1
    })) : _createCommentVNode("", true)], 42, _hoisted_8);
  }), 128))], 512), [[_vShow, _ctx.showModelList]]), _ctx.hoverItem ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.hoverItem.name), 1), _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.hoverItem.desc), 1), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("div", _hoisted_16, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, item => {
    return _createElementVNode("div", {
      key: item,
      class: _normalizeClass(["rounded", {
        ok: item + 1 <= _ctx.hoverItem.reasoning
      }])
    }, null, 2);
  }), 64))])]), _createElementVNode("div", _hoisted_17, [_hoisted_18, _createElementVNode("div", _hoisted_19, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, item => {
    return _createElementVNode("div", {
      key: item,
      class: _normalizeClass(["rounded", {
        ok: item + 1 <= _ctx.hoverItem.speed
      }])
    }, null, 2);
  }), 64))])]), _createElementVNode("div", _hoisted_20, [_hoisted_21, _createElementVNode("div", _hoisted_22, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, item => {
    return _createElementVNode("div", {
      key: item,
      class: _normalizeClass(["rounded", {
        ok: item + 1 <= _ctx.hoverItem.conciseness
      }])
    }, null, 2);
  }), 64))])])])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_23, [_hoisted_24, _createElementVNode("div", _hoisted_25, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quickTips, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "text-xs cursor-pointer border shadow-md bg-white rounded p-3 w-64 md:w-auto",
      key: index
    }, [_createElementVNode("div", _hoisted_26, [_createElementVNode("img", {
      class: "w-6",
      src: require(`@/assets/welcome/${index + 1}.png`)
    }, null, 8, _hoisted_27), _createElementVNode("div", _hoisted_28, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_29, _toDisplayString(item.desc), 1)]), _createElementVNode("ul", _hoisted_30, [_createVNode(_component_el_scrollbar, {
      class: "font-normal text-gray-600 mt-2 h-20 pb-5 overflow-y-auto",
      onClick: $event => _ctx.quickMessage(item.prompt)
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.prompt), 1)]),
      _: 2
    }, 1032, ["onClick"])])]);
  }), 128))])]), _createElementVNode("div", _hoisted_31, [_hoisted_32, _createTextVNode(" 为了方便您以后能找到我们的网站，请按 "), _hoisted_33, _createTextVNode("收藏吧，或者下载 "), _createElementVNode("div", {
    onClick: _cache[2] || (_cache[2] = (...args) => _ctx.download && _ctx.download(...args)),
    class: "flex items-center"
  }, _hoisted_36), _createTextVNode(" 拖至桌面 ")])]);
}